import { MessageModalTypes } from './message-modal.types';

export const toggleMessageModal = () => ({
  type: MessageModalTypes.OPEN_MESSAGE_MODAL,
});
